import Vue from 'vue'
import {Route} from 'vue-router';
import appConfig from '@/config'
import { arrayHelper } from '@/lib/utils'
import base from './types/base'
import { appConst } from '@/lib/consts'
import { TabRoute } from '../entity';

class MenuRouteHelper{
  hasChild(item:any) {
    return item.children && item.children.length !== 0
  }

  showThisMenuEle(item:any, access:Array<any>){
    if (item.meta && item.meta.access && item.meta.access.length) {
      if (arrayHelper.hasOneOf(item.meta.access, access)) return true
      else return false
    } else return true
  }

  /**
   * @param {Array} list 通过路由列表得到菜单列表
   * @returns {Array}
   */
  getMenuByRouterForCurrentUser = (list:Array<any>, access:Array<string>) => {
    return this.getMenuByRouter(list,access);
  }

  /**
   * @param {Array} list 通过路由列表得到菜单列表
   * @returns {Array}
   */
  getMenuByRouter = (list:Array<any>, access:Array<any>) => {
    let res = []
    arrayHelper.forEach(list, item => {
      if (!item.meta || (item.meta && !item.meta.hideInMenu)) {
        let obj = {
          icon: (item.meta && item.meta.icon) || '',
          name: item.name,
          meta: item.meta,
          children:[],
          href:''
        }
        if ((this.hasChild(item) || (item.meta && item.meta.showAlways)) && this.showThisMenuEle(item, access)) {
          obj.children = this.getMenuByRouter(item.children, access);
        }

        // if(this.hasChild(item) && item.children[0].meta.isDefault){
        //   obj.defaultChild = item.children[0].name;
        // }
        if (item.meta && item.meta.href) obj.href = item.meta.href
        if (this.showThisMenuEle(item, access)) res.push(obj);
      }
    })
    return res;
  }
  /*获取Tab页上的父级菜单路由 */
  getMenuRoute(route:any){
    if(route.matched){
      const getParentRoute = (parent,child)=>{
        if(parent.meta && !parent.meta.hideInMenu){
          return parent;
        } else{
          if(parent.parent){
            return getParentRoute(parent.parent,child);
          }
          else{
            return child;
          }
        }
      };

      let currentRoute = route.matched[route.matched.length-1];
      return getParentRoute(currentRoute,route);
    }
    else{
      return route;
    }
  }

  /**
 * @param {Array} routeMetched 当前路由metched
 * @returns {Array}
 */
  getBreadCrumbList(route:any, homeRoute:any){
    let homeItem = { ...homeRoute, icon: homeRoute.meta.icon }
    let routeMetched = route.matched
    let res = [];
    if(routeMetched){
      if (routeMetched.some(item => item.name === homeRoute.name)) return [homeItem]
      res = routeMetched.filter(item => {
        return item.meta === undefined || !item.meta.hideInBread
      }).map(item => {
        let meta = { ...item.meta }
        if (meta.title && typeof meta.title === 'function') {
          meta.__titleIsFunction__ = true
          meta.title = meta.title(route)
        }
        let obj = {
          icon: (item.meta && item.meta.icon) || '',
          name: item.name,
          meta: meta
        }
        return obj
      })
      // res = res.filter(item => {
      //   return !item.meta.hideInMenu
      // })
    } else{
      if(route.meta && !route.meta.hideInMenu){
        res.push(route);
      }
    }

    return [...res]
    //return [{ ...homeItem, to: homeRoute.path }, ...res]
  }

  getRouteTitleHandled(route: Route){
    let router = { ...route }
    let meta = { ...route.meta }
    let title = ''
    if (meta.title) {
      if (typeof meta.title === 'function') {
        meta.__titleIsFunction__ = true
        title = meta.title(router)
      } else title = meta.title
    }
    meta.title = title
    router.meta = meta
    return router
  }

  showTitle = (item:any, vm?:any) => {
    let { title, __titleIsFunction__ } = item.meta
    if (!title) return
    if (appConfig.useI18n) {
      // if (title.includes('{{') && title.includes('}}') && appConfig.useI18n) title = title.replace(/({{[\s\S]+?}})/, (m, str) => str.replace(/{{([\s\S]*)}}/, (m, _) => base.L(_.trim())))
      // else if (__titleIsFunction__) title = item.meta.title
      // else title = base.L(item.name)
      title = base.L(item.meta.title);
    } else title = (item.meta && item.meta.title) || item.name
    return title
  }
  /**
   * @description 本地存储和获取标签导航列表
   */
  setTagNavListInLocalstorage(list:any){
    localStorage.tagNaveList = JSON.stringify(list)
    //localStorage.tagNaveList = list
  }

  /**
   * @returns {Array} 其中的每个元素只包含路由原信息中的name, path, meta三项
   */
  getTagNavListFromLocalstorage():Array<any>{
    const list = localStorage.tagNaveList
    if(typeof list ==='string'){
      return list ? JSON.parse(list) : []
    }
    //return list ? JSON.parse(list) : []
    return list ? list : []
  }

  /**
   * @param {Array} routers 路由列表数组
   * @description 用于找到路由列表中name为home的对象
   */
  getHomeRoute(routers:Array<any>, homeName:string = 'home') {
    let i = -1
    let len = routers.length
    let homeRoute = {}
    while (++i < len) {
      let item = routers[i]
      if(item instanceof TabRoute){
        item = item.menuRoute;
      }
      if (item.children && item.children.length) {
        let res = this.getHomeRoute(item.children, homeName)
        if (res.name) return res
      } else {
        if (item.name === homeName) homeRoute = item
      }
    }
    return homeRoute
  }

  /**
   * @param {*} list 现有标签导航列表
   * @param {*} newRoute 新添加的路由原信息对象
   * @description 如果该newRoute已经存在则不再添加
   */
  getNewTagList(list:Array<any>, tabRoute:TabRoute){
    // //非标签路由过滤
    // let tabRoute = this.getMenuRoute(newRoute);
    let newRoute = menuRouteHelper.copyRoute(tabRoute);
    let newList = [...list]
    let index = newList.findIndex(item => item.name === newRoute.name);
    if ( index>= 0){

      return newList
    } 
    else newList.push(newRoute)
    return newList
  }

  /**
   * @param {*} access 用户权限数组，如 ['super_admin', 'admin']
   * @param {*} route 路由列表
   */
  hasAccess(route:any){
    if (route.meta && route.meta.access) return  window.basic.auth.hasAllPermission(route.meta.access)
    else return true
  }
  /**
   * 权鉴
   * @param {*} name 即将跳转的路由name
   * @param {*} routes 路由列表
   * @description 用户是否可跳转到该页
   */
  canTurnTo(name:string, routes:any){
    const routePermissionJudge = (list) => {
      return list.some(item => {
        if (item.children && item.children.length) {
          return routePermissionJudge(item.children)
        } else if (item.name === name) {
          return this.hasAccess(item)
        }
      })
    }

    return routePermissionJudge(routes)
  }
  
   /**
   * 权鉴
   * @param {*} route 即将跳转的路由
   * @description 用户是否可跳转到该页
   */
  canDirectlyTurnTo(route:any){
    return this.hasAccess(route);
  }

  /**
   * @param {String} url
   * @description 从URL中解析参数
   */
  getParams(url:string){
    const keyValueArr = url.split('?')[1].split('&')
    let paramObj = {}
    keyValueArr.forEach(item => {
      const keyValue = item.split('=')
      paramObj[keyValue[0]] = keyValue[1]
    })
    return paramObj
  }
  /* 基于当前路由创建一个新的TabRoute对象*/
  createNewTabRoute(route:any):TabRoute {
    let tagRoute = new TabRoute();
    let menuRoute = this.getMenuRoute(route);
    tagRoute.menuRoute= menuRouteHelper.copyRoute(menuRoute);
    tagRoute.name= (menuRoute.meta && menuRoute.meta.defaultChild) ? menuRoute.meta.defaultChild: menuRoute.name;
    tagRoute.currentRoute= menuRouteHelper.copyRoute(route);
    tagRoute.history.push(menuRouteHelper.copyRoute(route));
    return tagRoute;
  }
  
  /**
   * @param {Array} list 标签列表
   * @param {*} route 当前关闭的标签的name
   */
  getNextRoute(list:Array<TabRoute>, route:any){
    let res = {}
    if (list.length <= 2) {
      res = this.getHomeRoute(list)
    } else {
      const index = list.findIndex(item => this.routeEqual(item.menuRoute, route))
      if (index === list.length - 1) res = list[list.length - 2]
      else res = list[index + 1]
    }
    return res
  }

/*复制路由 */
copyRoute(route:any){
  let {matched} = route
  const {fullPath,hash,meta,name,params,path,query} = route;

  if(matched && matched.length>0){
    let copyMatched = [];
    arrayHelper.forEach(matched, item=>{
      let {fullPath,hash,meta,name,params,path,query} = item;
      copyMatched.push({fullPath,hash,meta,name,params,path,query});
    });
    matched = copyMatched;
  }
  return {fullPath,hash,matched,meta,name,params,path,query};
}

  /**
   * @param {Number} times 回调函数需要执行的次数
   * @param {Function} callback 回调函数
   */
  doCustomTimes(times:number, callback:any){
    let i = -1
    while (++i < times) {
      callback(i)
    }
  }

  showByAccess(access:any, canViewAccess:any){
    return arrayHelper.hasOneOf(canViewAccess, access)
  }
  
  /**
   * @description 根据name/params/query判断两个路由对象是否相等
   * @param {*} route1 路由对象
   * @param {*} route2 路由对象
   */
  routeEqual(route1:any, route2:any){
    const params1 = route1.params || {}
    const params2 = route2.params || {}
    const query1 = route1.query || {}
    const query2 = route2.query || {}
    return (route1.name === route2.name) && arrayHelper.objEqual(params1, params2) && arrayHelper.objEqual(query1, query2)
  }
  
  /**
   * 判断打开的标签列表里是否已存在这个新添加的路由对象
   */
  routeHasExist(tagNavList:Array<TabRoute>, routeItem:any){
    let len = tagNavList.length
    let res = false
    this.doCustomTimes(len, (index) => {
      if (this.routeEqual(tagNavList[index], routeItem)) res = true
    })
    return res
  }
  
  /*获取naveTabList中的TabRoute */
  getNavTabRoute(tagNaveList:Array<TabRoute>,route:any){
    let menuRoute = this.getMenuRoute(route);
    let tabRouteList = tagNaveList.filter(item=>item.name === menuRoute.name);
    if(tabRouteList && tabRouteList.length>0){
      return tabRouteList[0];
    }

    return null;
  }


  getHistory(currentTabRoute:TabRoute,currentRoute:any){
    //若当前路由从菜单直接点入，则清空对应菜单的历史页面记录
    if(currentRoute.params&& currentRoute.params.actionCode==="reset" && currentTabRoute.history.length>0){
      if(currentRoute.fullPath===currentTabRoute.history[0].fullPath){
         let newCurrentRoute = menuRouteHelper.copyRoute(currentRoute);
        return [newCurrentRoute];
      }
    }

    //如果是从历史堆栈中返回，则不再计入历史堆栈中。
    if(!currentRoute.meta || !currentRoute.meta.isHistoryBack){
      let newCurrentRoute = menuRouteHelper.copyRoute(currentRoute);
      const lastHistoryIndex = currentTabRoute.history.length-1;
      if(lastHistoryIndex>=0){
        let lastRoute = currentTabRoute.history[lastHistoryIndex];
        //如果堆栈中最后一个路由与当前路由不一致，则入栈。
        if(!this.routeEqual(lastRoute, newCurrentRoute)){
          currentTabRoute.history.push(newCurrentRoute);
          return [...currentTabRoute.history];
        }
      } else {
        return [newCurrentRoute];
      }
    }

    return [...currentTabRoute.history];
  }

  historyPush(tagNaveList:Array<TabRoute>,currentRoute:any){
    //如果是从历史堆栈中返回，则不再计入历史堆栈中。
    if(!currentRoute.meta || !currentRoute.meta.isHistoryBack){
      let currentTagRoute = this.getMenuRoute(currentRoute);
      const index = tagNaveList.findIndex(item => this.routeEqual(item.menuRoute, currentRoute));
      //找到对应菜单Tab页的路由记录，若无此菜单，则不做历史入栈（因为在此之前系统会添加到tagNaveList中去。
      if(index>=0){
        const lastHistoryIndex = tagNaveList[index].history.length-1;
        if(lastHistoryIndex>=0){
          let lastRoute = tagNaveList[index].history[lastHistoryIndex];
          //如果堆栈中最后一个路由与当前路由不一致，则入栈。
          if(!this.routeEqual(lastRoute, currentRoute)){
            tagNaveList[index].history.push(currentRoute);
          }
        } else{
          tagNaveList[index].history.push(currentRoute);
        }
      } 
    }
  }


  historyBack(tagNaveList:Array<TabRoute>,currentRoute:any){
    let currentTagRoute = this.getMenuRoute(currentRoute);
    const index = tagNaveList.findIndex(item => this.routeEqual(item.menuRoute, currentTagRoute));
    //找到对应菜单Tab页的路由记录，若无此菜单，则不做任何处理（因为在此之前系统会添加到tagNaveList中去。
    if(index>=0){
      let lastHistoryIndex = tagNaveList[index].history.length-1;

      if(lastHistoryIndex>=0){

        let backRoute = tagNaveList[index].history[lastHistoryIndex];
        // let backRoute = tagNaveList[index].history.pop();
        //如果堆栈中最后一个路由与当前路由一致，则弹出，并返回倒数第二个路由。
        if(this.routeEqual(backRoute, currentRoute)){
          tagNaveList[index].history.pop();
          lastHistoryIndex = tagNaveList[index].history.length-1;
          if(lastHistoryIndex>=0){
            backRoute= tagNaveList[index].history[tagNaveList[index].history.length-1];
          } else {
            //if get root already, then return false.
            return false
          }
        }
        backRoute.meta = Object.assign(backRoute.meta||{},{isHistoryBack:true});
        return backRoute;
      } else{
        //若历史堆栈中已无历史路由，则不做任何操作。
        console.log('No backward route in history stack');
        return false;
      }
    }
    return false; 
  }

  /**
   * @description 根据当前跳转的路由设置显示在浏览器标签的title
   * @param {Object} routeItem 路由对象
   * @param {Object} vm Vue实例
   */
  setTitle = (routeItem:any, vm:Vue) => {
    const handledRoute = this.getRouteTitleHandled(routeItem)
    const pageTitle = this.showTitle(handledRoute, vm)
    const resTitle = pageTitle ? `${appConfig.title} - ${pageTitle}` : appConfig.title
    window.document.title = resTitle
  }
}
export const menuRouteHelper = new MenuRouteHelper()